import addDays from 'date-fns/add_days';
import addHours from 'date-fns/add_hours';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import getDatePicker from 'owa-mail-list-context-menu/lib/helpers/getDatePicker';
import getDay from 'date-fns/get_day';
import strings from 'owa-strings/owa-mail-strings';
import { lazyScheduleItems } from 'owa-mail-triage-action';
import { listViewStore } from 'owa-mail-list-store';
import { now } from 'owa-datetime/lib/displaydate/now';
import { ContextualMenuItemType, } from 'office-ui-fabric-react/lib/ContextualMenu';
export var hourOffsetRegular = 8;
var hourOffsetLater = 3;
var hourOffsetEvening = 18;
var hourOffsetWeekend = 10;
var styles = require('../components/ScheduleDatePicker.scss');
var DayTexts;
(function (DayTexts) {
    DayTexts[DayTexts["Sun"] = 0] = "Sun";
    DayTexts[DayTexts["Mon"] = 1] = "Mon";
    DayTexts[DayTexts["Tue"] = 2] = "Tue";
    DayTexts[DayTexts["Wed"] = 3] = "Wed";
    DayTexts[DayTexts["Thu"] = 4] = "Thu";
    DayTexts[DayTexts["Fri"] = 5] = "Fri";
    DayTexts[DayTexts["Sat"] = 6] = "Sat";
})(DayTexts || (DayTexts = {}));
// Schedule 3 hours into future
export function laterDate(date) {
    var laterDate = addHours(date, hourOffsetLater);
    laterDate.setMinutes(0, 0, 0);
    return laterDate;
}
// Schedule for evening
function eveningDate(date) {
    var laterDate = date;
    laterDate.setHours(hourOffsetEvening, 0, 0, 0);
    return laterDate;
}
// Schedule for tomorrow
function tomorrowDate(date) {
    var laterDate = addDays(date, 1);
    laterDate.setHours(hourOffsetRegular, 0, 0, 0);
    return laterDate;
}
// Schedule for weekend (next saturday)
function weekendDate(date) {
    var laterDate = getNextDay(date, DayTexts.Sat, hourOffsetWeekend);
    return laterDate;
}
// Schedule for next week (next monday)
function firstWeekdayDate(date) {
    var laterDate = getNextDay(date, DayTexts.Mon, hourOffsetRegular);
    return laterDate;
}
// Day of week string representation
function getDayText(date) {
    var day = getDay(date);
    return DayTexts[day] + ' ';
}
// Calculate the next day that satisfies offset
function getNextDay(date, dow, hour) {
    // Copy to avoid destructive modification
    var laterDate = new Date(date.getTime());
    laterDate.setDate(laterDate.getDate() + ((dow + (7 - laterDate.getDay())) % 7));
    laterDate.setHours(hour, 0, 0, 0);
    return laterDate;
}
// Schedule for 8 AM
export function morningDate(date) {
    date.setHours(hourOffsetRegular, 0, 0, 0);
    return date;
}
export default function createScheduleSubMenu(rowKeys, tableViewId, actionSource) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var scheduleSubMenu = [];
    var currentTime = now();
    var laterToday = laterDate(currentTime);
    var tomorrow = tomorrowDate(currentTime);
    var evening = eveningDate(currentTime);
    var weekend = weekendDate(currentTime);
    var firstWeekday = firstWeekdayDate(currentTime);
    scheduleSubMenu.push({
        key: strings.scheduleLaterToday,
        name: strings.scheduleLaterToday,
        iconProps: {
            iconName: 'Clock',
        },
        secondaryText: laterToday.toLocaleString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        }),
        onClick: function () {
            lazyScheduleItems.importAndExecute(rowKeys, tableView, actionSource, false, laterToday);
        },
    });
    // If laterToday does not surpass evening time stamp AND laterToday does not
    // spill over into the next day, show laterToday.
    if (evening > laterToday && laterToday.getDate() == currentTime.getDate()) {
        scheduleSubMenu.push({
            key: strings.scheduleThisEvening,
            name: strings.scheduleThisEvening,
            iconProps: {
                iconName: 'ClearNight',
            },
            secondaryText: evening.toLocaleString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
            }),
            onClick: function () {
                lazyScheduleItems.importAndExecute(rowKeys, tableView, actionSource, false, evening);
            },
        });
    }
    scheduleSubMenu.push({
        key: strings.scheduleTomorrow,
        name: strings.scheduleTomorrow,
        iconProps: {
            iconName: 'CoffeeScript',
        },
        secondaryText: getDayText(tomorrow) +
            tomorrow.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }),
        onClick: function () {
            lazyScheduleItems.importAndExecute(rowKeys, tableView, actionSource, false, tomorrow);
        },
    });
    scheduleSubMenu.push({
        key: strings.scheduleThisWeekend,
        name: strings.scheduleThisWeekend,
        iconProps: {
            iconName: 'Vacation',
        },
        secondaryText: getDayText(weekend) +
            weekend.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }),
        onClick: function () {
            lazyScheduleItems.importAndExecute(rowKeys, tableView, actionSource, false, weekend);
        },
    });
    scheduleSubMenu.push({
        key: strings.scheduleNextWeek,
        name: strings.scheduleNextWeek,
        iconProps: {
            iconName: 'Suitcase',
        },
        secondaryText: getDayText(firstWeekday) +
            firstWeekday.toLocaleString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
            }),
        onClick: function () {
            lazyScheduleItems.importAndExecute(rowKeys, tableView, actionSource, false, firstWeekday);
        },
    });
    scheduleSubMenu.push({
        key: strings.scheduleChooseDate,
        name: strings.scheduleChooseDate,
        iconProps: {
            iconName: 'Calendar',
        },
        subMenuProps: {
            items: [
                {
                    key: 'schedulePicker',
                    name: 'schedulePicker',
                    onRender: function (item, dismissMenu) {
                        return getDatePicker(tomorrow, rowKeys, tableView, actionSource, dismissMenu);
                    },
                },
            ],
        },
    });
    if (tableView.tableQuery.type == 0 /* Folder */ &&
        folderIdToName(tableView.tableQuery.folderId) == 'scheduled') {
        scheduleSubMenu.push({
            key: '-',
            itemType: ContextualMenuItemType.Divider,
        });
        scheduleSubMenu.push({
            key: strings.scheduleUnschedule,
            name: strings.scheduleUnschedule,
            className: styles.unscheduleText,
            iconProps: {
                iconName: 'Blocked',
            },
            onClick: function () {
                lazyScheduleItems.importAndExecute(rowKeys, tableView, actionSource, true /* unschedule */);
            },
        });
    }
    return {
        items: scheduleSubMenu,
        className: styles.fixWidthContextMenu,
        directionalHintFixed: true,
    };
}
//# sourceMappingURL=createScheduleSubMenu.js.map